// Configuration i18next. Initialisée une seule fois au boot.
// Stratégie : ressources inline pour les namespaces critiques (navbar, footer, common)
// afin d'éviter un round-trip réseau au premier rendu (impact LCP).

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "./locales/fr/common.json";
import enCommon from "./locales/en/common.json";

export const SUPPORTED_LANGS = ["fr", "en"] as const;
export const DEFAULT_LANG = "fr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: frCommon },
      en: { common: enCommon },
    },
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false }, // React échappe déjà
    detection: {
      // On laisse useLang() (basé sur l'URL) être la source de vérité.
      // Le détecteur sert uniquement au bandeau "Switch to English" qui lit navigator.language.
      order: ["path", "navigator"],
      lookupFromPathIndex: 0,
      caches: [], // pas de localStorage : la langue est portée par l'URL
    },
    react: { useSuspense: false },
  });

export default i18n;
